var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 99,
    viewBox: "0 0 72 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6518_448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1141 3.53405e-06H35.9973C31.2722 -0.00209384 26.5929 0.929388 22.2266 2.74126C17.8604 4.55314 13.8926 7.20993 10.55 10.5599C7.20731 13.9099 4.55518 17.8876 2.74501 22.2657C0.934847 26.6438 0.00209 31.3367 0 36.0765L0 36.1084C0 45.8221 10.0818 61.2097 10.0818 61.2097L36.0027 99L62.0509 61.0553C62.0509 61.0553 72 45.8221 72 36.2415C72.0161 31.4982 71.1006 26.7983 69.3058 22.41C67.5111 18.0216 64.8722 14.0309 61.5399 10.6655C58.2076 7.30019 54.247 4.62619 49.8845 2.79619C45.5219 0.966199 40.8427 0.0160527 36.1141 3.53405e-06Z",
    fill: "#068EB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6518_448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIcon);
export default __webpack_public_path__ + "static/media/BlueIcon.daf2d1c836df479b8bfc2c42d49df458.svg";
export { ForwardRef as ReactComponent };